import { USER_NOTIFICATION_ADD, SHOW_NOTIFICATION_SNACKBAR } from "../actionTypes/actionTypes";

export function addNotifications(notifications) {
    return [
        { type: USER_NOTIFICATION_ADD, notifications },
        { type: SHOW_NOTIFICATION_SNACKBAR, notifications }
    ]
}